import React from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomTooltip from "./CustomTooltip";
import { checkFormSubmitForVendor, clearWebForm } from "../../redux/actions/vendor/webFormActions";
import { routineInspectionClearWebForm } from "../../redux/actions/vendor/routineInspectionWebFormActions";
import { scmCheckFormSubmitForVendor } from "../../redux/actions/vendor/scmWebFormActions";

const HomeIconButton = () => {
  const navigate = useNavigate();
  const dispatch=useDispatch()
  const handleClick = () => {
    if (localStorage.getItem("roleName") === "DeptUser") {
        navigate("/UserDeptDashboard");
    } else if (localStorage.getItem("roleName") === "Vendors") {
        navigate("/VendorDashboard");
         dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch(clearWebForm("CLEAR_WEB_FORM", {}));
            dispatch(routineInspectionClearWebForm("ROUTINEINSPECTION_CLEAR_WEB_FORM", {}));
            dispatch(checkFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", ""));
            dispatch(scmCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", ""));
    } else {
        navigate("/dashboard");
    }
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
};

  return (
    <CustomTooltip
      title="Dashboard"
      placement="bottom"
      disableFocusListener
      disableInteractive
    >
      <IconButton aria-label="home" disableRipple onClick={handleClick}>
        <HomeIcon />
      </IconButton>
    </CustomTooltip>
  );
};

export default HomeIconButton;
